module.exports = __webpack_public_path__ + "static/media/ParticipantsIcon.d613196a.svg";